<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title title="Resumo de anúncios disponibilizados">
        <div slot="header-icon">
          <img :src="fromModuleDefinition.logo" class="logo" alt="">
          <i class="i-arrow icon-arrow-right"></i>
          <img :src="toModuleDefinition.logo" class="logo" alt="">
        </div>
      </page-title>
      <div class="l-row">
        <div class="l-col-3@md" v-for="product in products" :key="product.productId">
          <marketplace-announcement-report-product-mercado-livre ref="items" :product="product" :account="getProductAccount(product.account.identifier)"/>
        </div>
      </div>

      <panel>
        <button class="btn btn--success" @click="done">{{ $t('done.label') }}</button>
      </panel>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import Panel from '@/components/template/Panel'
  import PageTitle from '@/components/template/PageTitle'
  import MarketplaceAnnouncementReportProductMercadoLivre from '@/components/marketplace/mercadoLivre/announcement/report/Product'
  import Loader from '@/components/template/Loader'

  export default {
    data: () => ({
      loading: true,
      saving: false
    }),
    props: {
      fromModuleType: {
        type: String,
        required: true
      },
      fromModuleIdentifier: {
        type: String,
        required: true
      }
    },
    async mounted () {
      if (!this.products.length) {
        this.redirectToProductProvideList()
      }

      if (!this.accounts.length) {
        await this.fetchAccounts({
          options: {
            active: true
          }
        })
      }

      this.loading = false
    },
    computed: {
      ...mapFields({
        accounts: 'mercadoLivreAccounts.accounts'
      }),
      ...mapGetters('sendAnnouncements', [
        'getAllVariations'
      ]),
      ...mapGetters('mercadoLivreAccounts', [
        'getAccount'
      ]),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      products () {
        return this.getAllVariations()
      },
      fromModuleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType(this.fromModuleType, this.fromModuleIdentifier)
      },
      toModuleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', 'mercadoLivre')
      }
    },
    methods: {
      ...mapActions('mercadoLivreAccounts', [
        'fetchAccounts',
        'setAccounts'
      ]),
      redirectToProductProvideList () {
        this.$router.push(`/${this.fromModuleType}/${this.fromModuleIdentifier}/products`)
      },
      done () {
        this.$router.push(`/marketplace/mercadoLivre/announcements`)
      },
      getProductAccount (accountIdentifier) {
        const account = this.getAccount(accountIdentifier)

        return account
      }
    },
    components: {
      Panel,
      PageTitle,
      Loader,
      MarketplaceAnnouncementReportProductMercadoLivre
    }
  }
</script>



// WEBPACK FOOTER //
// Report.vue?112cd166